module.exports = __webpack_public_path__ + "resources/img/img_i_onenet2_m_en.d60e38b8c679afd8edf7504760da4759.png";